export default "__VITE_ASSET__b4eb30dc__"